import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=18e51604&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=18e51604&prod&lang=stylus"
import style1 from "./TagsView.vue?vue&type=style&index=1&id=18e51604&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e51604",
  null
  
)

export default component.exports